export default __webpack_public_path__ + "static/HeroSectionRight_us-689f472fcfcab80aea90a9779a6a9b1b.png";